module.exports = __webpack_public_path__ + "static/media/circle-exportUser.97506295.svg";